<template>
  <div>
    <div v-if="!$slots.default" class="tbl-filter-item">
      <label v-if="field" :for="`${field}-filter`">{{ label_display }}</label>
      <b-input-group>
        <b-input-group-prepend>
          <div class="input-group-text">
            <i class="la la-search" />
          </div>
        </b-input-group-prepend>
        <input type="text"
               :name="`${field}-filter`"
               class="form-control"
               :placeholder="placeholder"
               @keyup="(event) => scalarFilter ? defaultCallback(event) : () => {}">
      </b-input-group>
    </div>
    <div v-else class="tbl-filter-item">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: String,
      required: false,
      default: ``,
    },
    display: {
      type: String,
      required: false,
      default: ``,
    },
    placeholder: {
      type: String,
      required: false,
      default: ``,
    },
    scalarFilter: {
      type: Boolean,
      required: false,
      default: true,
    },
    scope: {
      type: Object,
      required: false,
      default: null,
    },
    layout: {
      type: String,
      required: false,
      default: `column`,
    },
  },
  data: () => ({
    label_display: ``,
  }),
  mounted() {
    this.label_display = (this.display === `` && this.field !== ``) ? `${this.field.charAt(0).toUpperCase()}${this.field.slice(1)}:` : this.display;
  },
  methods: {
    defaultCallback(event) {
      const payload = {
        value: event.target.value,
        op: `ct`,
        field: this.field,
      };
      this.scope.filterChange({
        client: payload,
        server: {
          type: `scalar`,
          ...payload,
        },
      });
    },
  },
};
</script>
